import type {companyGroupState, companyGroupAction} from './types'

const INITIAL_STATE: companyGroupState = {
  loading: false,
  meta: {
    page: 0,
    limit: 10,
    total: 0,
    pageCount: 0,
    hasPrevious: false,
    hasNext: false,
  },
  data: undefined,
}

export const companyGroupReducer = (
  prev: companyGroupState = INITIAL_STATE,
  action: companyGroupAction
): companyGroupState => {
  switch (action.type) {
    case 'COMPANY_GROUP/SET_DATA':
      return {
        ...prev,
        data: action.payload,
      }
    case 'COMPANY_GROUP/SET_META':
      return {
        ...prev,
        meta: action.payload,
      }
    case 'COMPANY_GROUP/SET_LOADING':
      return {
        ...prev,
        loading: action.payload,
      }
    case 'COMPANY_GROUP/GET_DATA':
      return {
        ...prev,
      }

    default:
      return prev
  }
}
